import { UsageRequest } from '../services/inferenceApi';

export const LOW_BALANCE_THRESHOLD = 100;

export function isLowBalance(balance: number): boolean {
  return balance < LOW_BALANCE_THRESHOLD;
}

export interface DaySeriesPoint {
  day: string;
  tokens: number;
  cost: number;
  requests: number;
}

// groupByDay aggregates usage requests into ascending per-day points for the charts.
export function groupByDay(rows: Pick<UsageRequest, 'created_at' | 'total_tokens' | 'total_cost'>[]): DaySeriesPoint[] {
  const byDay = new Map<string, DaySeriesPoint>();
  for (const r of rows) {
    const day = r.created_at.slice(0, 10);
    const point = byDay.get(day) ?? { day, tokens: 0, cost: 0, requests: 0 };
    point.tokens += r.total_tokens ?? 0;
    point.cost += r.total_cost ?? 0;
    point.requests += 1;
    byDay.set(day, point);
  }
  return Array.from(byDay.values()).sort((a, b) => a.day.localeCompare(b.day));
}
